import { render, staticRenderFns } from "./accordion-element.vue?vue&type=template&id=6f1ac193&scoped=true"
import script from "./accordion-element.vue?vue&type=script&lang=js"
export * from "./accordion-element.vue?vue&type=script&lang=js"
import style0 from "./accordion-element.vue?vue&type=style&index=0&id=6f1ac193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ac193",
  null
  
)

export default component.exports